import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google'; 


import Login from './signup/Login.jsx'; 
import Signup from './signup/Signup.jsx'; 
import './signup/Login.css'; 

const GOOGLE_CLIENT_ID = "787134372134-1kunpdlr7k8eh04slv1kpdek37ssm9rn.apps.googleusercontent.com"; 


function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <div className="auth-page-wrapper">
            <Router>
                <Routes>
                    <Route path="/" element={<Signup />} />
                    <Route path="/login" element={<Login />} />
                </Routes>
            </Router>
        </div>
    </GoogleOAuthProvider>
  );
}

export default App;